module.exports = __webpack_public_path__ + "static/media/calculator.a2a3bf28.png";